import { Fetch } from 'lib';
import type { Tag } from 'types';

type RequestResponses = Tag;

type RequestParameters = {};

type RequestBody = Prettify<
  StrictOmit<Tag, 'id' | 'categories'> &
    Partial<Record<'categoriesIds', string[]>>
>;

const createTag = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminTag/createTag',
    method: 'POST',
    body,
  });

export { createTag };
